import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{loading-spinner}}\n{{hide-application-footer}}",{ moduleName: "discourse/templates/loading.hbs" })